import React, { useState } from 'react'
import { Table, Typography } from 'antd'
import { useFetch } from 'use-http'

import GenericCard from '../../generic-card'
import MetricNumber from '../../metric-number'
import TrendInfo from '../../trend-info'
import DateRangePicker from '../../range-picker'

import { createAdminGetUrl } from 'utils'

const { Column } = Table
const { Text } = Typography

const MatriculasPorFormaDePagamento = () => {
  const [dateRange, setDateRange] = useState({
    startDate: '01%2F01%2F1900',
    endDate: '01%2F01%2F1900',
  })

  const { data, loading, error } = useFetch(
    createAdminGetUrl(
      'DashMKTVendasMatriculasFormaPGTO',
      `${dateRange.startDate}/${dateRange.endDate}`
    ),
    null,
    [dateRange]
  )

  return (
    <GenericCard
      error={error}
      loading={loading}
      title="Matrículas por forma de pagamento"
      rightComponent={
        <DateRangePicker
          initialValues={{ startDate: data?.inicio, endDate: data?.fim }}
          onDateSelection={setDateRange}
        />
      }
    >
      <Table
        size="small"
        showHeader={false}
        pagination={false}
        dataSource={data ? data.matriculas : []}
      >
        <Column
          dataIndex="matriculas"
          key="matriculas"
          align="right"
          render={value => {
            return (
              <MetricNumber value={Number(value)}>
                {({ formatedNumber }) => formatedNumber}
              </MetricNumber>
            )
          }}
        />

        <Column dataIndex="forma_pgto" key="forma_pgto" align="right" />
      </Table>
    </GenericCard>
  )
}

export { MatriculasPorFormaDePagamento }
